import React from 'react';
import { Styles } from '../styles/courseCategory.js';

const CourseCategory = ({
    categories = [],
    loading,
    selectedCategories = [],
    onToggleCategory = () => {}
}) => {
    const displayCategories = React.useMemo(() => {
        const existing = [...categories];
        selectedCategories.forEach((label) => {
            if (label && !existing.find((item) => item.label === label)) {
                existing.push({ label, count: 0 });
            }
        });
        return existing;
    }, [categories, selectedCategories]);

    return (
        <Styles>
            <div className="course-category">
                <h5>Course Category</h5>
                {loading ? (
                    <p className="loading text-muted">Loading categories…</p>
                ) : displayCategories.length === 0 ? (
                    <p className="empty text-muted">No categories available.</p>
                ) : (
                    <ul className="category-item list-unstyled">
                        {displayCategories.map((category) => {
                            const isSelected = selectedCategories.includes(category.label);
                            return (
                                <li
                                    className={`check-btn${isSelected ? ' active' : ''}`}
                                    key={category.label}
                                >
                                    <label>
                                        <input
                                            type="checkbox"
                                            className="check-box"
                                            checked={isSelected}
                                            onChange={() => onToggleCategory(category.label)}
                                            aria-checked={isSelected}
                                        />
                                        {category.label}
                                        <span>({category.count})</span>
                                    </label>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        </Styles>
    );
};

export default CourseCategory;
